import styled from 'styled-components';

export const IdleRecommendationGameDetailsBox = styled.div`
    letter-spacing: 0.5px;
`;
